import Restaurant from "./components/Restaurant App/Restaurant";
// import Counter from "./components/Restaurant App/useState";

function App() {
  return (
   <>
  <Restaurant></Restaurant>
  {/* <Counter></Counter> */}

   </>
  );
}

export default App;
